export const messages = {
  en: {
    shopSms: {
      smsSettings: 'SMS Settings',
      edit: 'Edit',
      sendDetails: 'Send Details',
      remainingSms: 'Remaining SMS:',
      unit: 'pcs',
      purchase: 'Purchase',
      smsSwitch: 'SMS Switch:',
      on: 'On',
      off: 'Off',
      smsPrice: 'SMS Price:',
      yuan: 'yuan',
      purchaseSms: 'Purchase SMS',
      unitPrice: 'Unit Price',
      purchaseQuantity: 'Purchase Quantity',
      paymentAmount: 'Payment Amount',
      paymentQrCode: 'Payment QR Code',
      purchased: 'Purchased',
      selectSmsSwitch: 'Please select SMS switch status',
      selectPurchaseQuantity: 'Please select SMS purchase quantity',
      selectSmsSwitchRequired: 'Please select SMS switch status',
      selectPurchaseQuantityRequired: 'Please select SMS purchase quantity'
    }
  },
  zh: {
    shopSms: {
      smsSettings: '短信设置',
      edit: '修改',
      sendDetails: '发送明细',
      remainingSms: '剩余短信：',
      unit: '条',
      purchase: '购买',
      smsSwitch: '短信开关：',
      on: '开',
      off: '关',
      smsPrice: '短信单价：',
      yuan: '元',
      purchaseSms: '购买短信',
      unitPrice: '单价',
      purchaseQuantity: '购买数量',
      paymentAmount: '支付金额',
      paymentQrCode: '支付二维码',
      purchased: '已购买',
      selectSmsSwitch: '请选择短信开关状态',
      selectPurchaseQuantity: '请选择短信购买条数',
      selectSmsSwitchRequired: '请选择短信开关状态',
      selectPurchaseQuantityRequired: '请选择短信购买条数'
    }
  }
}